import { render } from "./PrimaryInsurance.vue?vue&type=template&id=31ed255a"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/billingInfo/forms/PrimaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31ed255a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31ed255a', __exports__)) {
    console.log('reload')
    api.reload('31ed255a', __exports__)
  }
  
  module.hot.accept("./PrimaryInsurance.vue?vue&type=template&id=31ed255a", () => {
    console.log('re-render')
    api.rerender('31ed255a', render)
  })

}


export default __exports__